import "../../App.css";
import "../admin/Schedule_Timings.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import TextField from "@mui/material/TextField";
import { Table } from "antd";

export default function ClinicViewDoctor() {
  const navigate = useNavigate();
  const params = useParams();
  const doctorId = params.doctorId;
  /** Admin route: /administration/clinicprofile/:PID/doctor/:doctorId */
  const clinicProfileId = params.PID;
  const clinicId = clinicProfileId || localStorage.getItem("clinicId");
  const WeekDay = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  const [doctorForm, setDoctorForm] = useState({
    doctorName: "",
    doctorEmail: "",
    doctorPassword: "",
    doctorTitle: "",
    doctorDegree: "",
    doctorMobile: "",
    ShowTransaction: 1,
  });
  const [degreeCertificateUrl, setDegreeCertificateUrl] = useState("");
  const [degreeCertificateFile, setDegreeCertificateFile] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [dashboardOption, setDashboardOption] = useState([
    true,
    false,
    false,
    false,
  ]);
  const [weekdayActive, setWeekdayActive] = useState("Monday");
  const [timeSlot, setTimeSlot] = useState([]);
  const [timeSlotActive, setTimeSlotActive] = useState([]);
  const [isSavingDoctor, setIsSavingDoctor] = useState(false);
  const [isSavingSlots, setIsSavingSlots] = useState(false);

  const bookingColumns = [
    {
      title: "Patient",
      dataIndex: "PatientName",
      key: "PatientName",
    },
    {
      title: "Booking Date",
      dataIndex: "BookingDate",
      key: "BookingDate",
    },
    {
      title: "Appointment",
      key: "Appt",
      render: (_, record) => `${record.Date || ""}  ${record.Time || ""}`,
    },
    {
      title: "Package",
      dataIndex: "Purpose",
      key: "Purpose",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
    },
    {
      title: "Status",
      key: "BookingStatus",
      render: (_, record) => {
        if (record.BookingStatus === 0) return "Pending";
        if (record.BookingStatus === 1) return "Accepted";
        if (record.BookingStatus === 2) return "Paid";
        return "Rejected";
      },
    },
  ];

  const transactionColumns = [
    {
      title: "Invoice",
      dataIndex: "Invoice",
      key: "Invoice",
    },
    {
      title: "Patient",
      key: "PatientName",
      render: (_, record) => record?.PatientDetails?.patientName || "",
    },
    {
      title: "Amount",
      dataIndex: "Amount",
      key: "Amount",
    },
    {
      title: "Paid On",
      dataIndex: "Paidon",
      key: "Paidon",
    },
    {
      title: "Time",
      dataIndex: "Time",
      key: "Time",
    },
    {
      title: "Package",
      dataIndex: "Purpose",
      key: "Purpose",
    },
  ];

  const loadDoctorAndBookings = () => {
    fetch(
      window.API_PREFIX +
        `admin/clinic_doctor_bookings?clinicId=${clinicId}&doctorId=${doctorId}&loginAs=${localStorage.getItem("LoginDetails") || "Clinic"}`
    )
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          navigate("/clinic");
          window.location.reload();
          return;
        }
        if (data?.status === "1") {
          const d = data?.Doctor || {};
          setDoctorForm((p) => ({
            ...p,
            doctorName: d.Name || "",
            doctorEmail: d.Email || "",
            doctorTitle: d.Title || "",
            doctorDegree: d.Degree || "",
            doctorMobile: d.MobileNo || "",
            ShowTransaction: Number(d.ShowTransaction || 0) === 1 ? 1 : 0,
          }));
          setDegreeCertificateUrl(d.DegreeCertificateUrl || "");
          setDegreeCertificateFile(null);
          setBookings(
            (data?.Booking || []).map((b, i) => ({
              key: b.BookingId || i,
              ...b,
            }))
          );
        } else {
          toast.error(data?.message || "Could not load doctor details");
        }
      })
      .catch(() => toast.error("Could not load doctor details"));
  };

  const loadSlots = (dayIndex) => {
    fetch(window.API_PREFIX + "timing/showslot_advance_doctor", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        Tag: dayIndex,
        ClinicId: parseInt(clinicId, 10),
        clinicId: parseInt(clinicId, 10),
        loginAs: localStorage.getItem("LoginDetails") || "Clinic",
        doctorId: parseInt(doctorId, 10),
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          navigate("/clinic");
          window.location.reload();
        } else if (data?.status === "1") {
          setTimeSlot([...(data?.TotalSlot || [])]);
          setTimeSlotActive([...(data?.ActiveSlot || [])]);
        } else {
          toast.error(data?.message || "Could not load slots");
        }
      });
  };

  const loadTransactions = () => {
    fetch(
      window.API_PREFIX +
        `admin/clinic_doctor_transactions?clinicId=${clinicId}&doctorId=${doctorId}&loginAs=${localStorage.getItem("LoginDetails") || "Clinic"}`
    )
      .then((r) => r.json())
      .then((data) => {
        if (data?.status === "Block") {
          toast.error(data?.message || "Unauthorized");
          localStorage.clear();
          navigate("/clinic");
          window.location.reload();
          return;
        }
        if (data?.status === "1") {
          setTransactions(
            (data?.Bill || []).map((t, i) => ({
              key: t.id || i,
              ...t,
            }))
          );
        } else {
          toast.error(data?.message || "Could not load transactions");
          setTransactions([]);
        }
      })
      .catch(() => {
        toast.error("Could not load transactions");
        setTransactions([]);
      });
  };

  useEffect(() => {
    if (!clinicId || !doctorId) return;
    loadDoctorAndBookings();
    loadSlots(0);
  }, [clinicId, doctorId]);

  return (
    <div className="container-fuild mx-2">
      <div className="component_division_mitwank_patient_profile">
        <div
          onClick={() => {
            navigate(
              clinicProfileId
                ? `/administration/clinicprofile/${clinicProfileId}`
                : "/clinic/clinic-add-doctor",
              clinicProfileId
                ? { state: { openAdminDoctorsTab: true } }
                : undefined,
            );
          }}
        >
          <button className="btn client_back_button">
            <i className="fa-solid fa-arrow-left back_icon"></i>Back
          </button>
        </div>

        <div className="mitwank_patient_profile_main_division mt-2">
          <div className="client_bashboard_tab_division">
            <div
              className={
                dashboardOption[0]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => setDashboardOption([true, false, false, false])}
            >
              <div className="client_bashboard_tabs_title_name">Profile</div>
            </div>
            <div
              className={
                dashboardOption[1]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => {
                loadDoctorAndBookings();
                setDashboardOption([false, true, false, false]);
              }}
            >
              <div className="client_bashboard_tabs_title_name">Appointments</div>
            </div>
            <div
              className={
                dashboardOption[2]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => {
                loadSlots(WeekDay.indexOf(weekdayActive));
                setDashboardOption([false, false, true, false]);
              }}
            >
              <div className="client_bashboard_tabs_title_name">Timing Slots</div>
            </div>
            <div
              className={
                dashboardOption[3]
                  ? "col client_bashboard_tabs_title_name_division_active"
                  : "col client_bashboard_tabs_title_name_division"
              }
              onClick={() => {
                loadTransactions();
                setDashboardOption([false, false, false, true]);
              }}
            >
              <div className="client_bashboard_tabs_title_name">Transactions</div>
            </div>
          </div>

          {dashboardOption[0] ? (
            <div className="p-3" style={{ border: "1px solid #eee", borderRadius: 12 }}>
              <div className="row mt-1">
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    size="small"
                    label="Doctor Name"
                    value={doctorForm.doctorName}
                    onChange={(e) =>
                      setDoctorForm((p) => ({ ...p, doctorName: e.target.value }))
                    }
                  />
                </div>
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    size="small"
                    label="Doctor Email"
                    value={doctorForm.doctorEmail}
                    onChange={(e) =>
                      setDoctorForm((p) => ({ ...p, doctorEmail: e.target.value }))
                    }
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-4">
                  <TextField
                    fullWidth
                    size="small"
                    label="Doctor Mobile"
                    value={doctorForm.doctorMobile}
                    onChange={(e) =>
                      setDoctorForm((p) => ({ ...p, doctorMobile: e.target.value }))
                    }
                  />
                </div>
                <div className="col-md-4">
                  <TextField
                    fullWidth
                    size="small"
                    label="Doctor Title"
                    value={doctorForm.doctorTitle}
                    onChange={(e) =>
                      setDoctorForm((p) => ({ ...p, doctorTitle: e.target.value }))
                    }
                  />
                </div>
                <div className="col-md-4">
                  <TextField
                    fullWidth
                    size="small"
                    label="Doctor Degree"
                    value={doctorForm.doctorDegree}
                    onChange={(e) =>
                      setDoctorForm((p) => ({ ...p, doctorDegree: e.target.value }))
                    }
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-12">
                  <label className="form-label small fw-semibold">
                    Degree certificate
                  </label>
                  {degreeCertificateUrl ? (
                    <div className="mb-2">
                      <a
                        href={degreeCertificateUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="small"
                      >
                        View current certificate
                      </a>
                    </div>
                  ) : null}
                  <input
                    type="file"
                    className="form-control form-control-sm"
                    accept=".pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/*"
                    onChange={(e) =>
                      setDegreeCertificateFile(e.target.files?.[0] || null)
                    }
                  />
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    size="small"
                    type="password"
                    label="New Password (optional)"
                    value={doctorForm.doctorPassword}
                    onChange={(e) =>
                      setDoctorForm((p) => ({
                        ...p,
                        doctorPassword: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="col-md-6 d-flex align-items-center">
                  <div className="form-check form-switch mt-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="clinicViewDoctorShowTransaction"
                      checked={Number(doctorForm.ShowTransaction) === 1}
                      onChange={(e) =>
                        setDoctorForm((p) => ({
                          ...p,
                          ShowTransaction: e.target.checked ? 1 : 0,
                        }))
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="clinicViewDoctorShowTransaction"
                    >
                      Show Transactions in Doctor Panel
                    </label>
                  </div>
                </div>
              </div>

              <div className="mt-3">
                <button
                  className="btn btn-dark"
                  disabled={isSavingDoctor}
                  onClick={() => {
                    if (!doctorForm.doctorName || !doctorForm.doctorEmail) {
                      toast.error("Name and email are required");
                      return;
                    }
                    setIsSavingDoctor(true);
                    const fd = new FormData();
                    fd.append("doctorId", String(parseInt(doctorId, 10)));
                    fd.append("doctorName", doctorForm.doctorName);
                    fd.append("doctorEmail", doctorForm.doctorEmail);
                    fd.append("doctorPassword", doctorForm.doctorPassword || "");
                    fd.append("doctorTitle", doctorForm.doctorTitle || "");
                    fd.append("doctorDegree", doctorForm.doctorDegree || "");
                    fd.append("doctorMobile", doctorForm.doctorMobile || "");
                    fd.append(
                      "ShowTransaction",
                      doctorForm.ShowTransaction ? "1" : "0",
                    );
                    fd.append(
                      "loginAs",
                      localStorage.getItem("LoginDetails") || "",
                    );
                    fd.append("clinicId", String(clinicId));
                    const recId = localStorage.getItem("receptionistId");
                    if (recId) fd.append("receptionistId", recId);
                    if (degreeCertificateFile) {
                      fd.append(
                        "doctorDegreeCertificate",
                        degreeCertificateFile,
                      );
                    }
                    fetch(window.API_PREFIX + "admin/edit_clinic_doctor", {
                      method: "POST",
                      body: fd,
                    })
                      .then((r) => r.json())
                      .then((data) => {
                        if (data?.status === "1") {
                          toast.success("Doctor updated successfully");
                          setDoctorForm((p) => ({ ...p, doctorPassword: "" }));
                          setDegreeCertificateFile(null);
                          loadDoctorAndBookings();
                        } else {
                          toast.error(data?.message || "Could not update doctor");
                        }
                      })
                      .catch(() => toast.error("Could not update doctor"))
                      .finally(() => setIsSavingDoctor(false));
                  }}
                >
                  {isSavingDoctor ? "Saving..." : "Save Doctor Details"}
                </button>
              </div>
            </div>
          ) : dashboardOption[1] ? (
            <div className="mitwank_patient_profile_table_division">
              <Table
                columns={bookingColumns}
                dataSource={bookings}
                pagination={{ pageSize: 10 }}
              />
            </div>
          ) : dashboardOption[2] ? (
            <div className="schedule_timings_main_diviison">
              <div className="schedule_timings_diviison">
                <div className="schedule_timings_week_division">
                  {WeekDay.map((eachDay, dayIndex) => (
                    <div
                      key={eachDay}
                      onClick={() => {
                        setWeekdayActive(eachDay);
                        loadSlots(dayIndex);
                      }}
                      className={
                        weekdayActive === eachDay
                          ? "schedule_timings_week_name_active"
                          : "schedule_timings_week_name"
                      }
                    >
                      {eachDay}
                    </div>
                  ))}
                </div>

                <div className="schedule_timings_time_slot_division">
                  <div className="schedule_timings_time_slote_title">Time slots</div>
                </div>
                <div className="schedule_timings_time_slot_table_division">
                  {timeSlot.map((eachTimeSlot, timeSlotIndex) => {
                    const label =
                      typeof eachTimeSlot === "string"
                        ? eachTimeSlot
                        : eachTimeSlot?.Slot ?? String(eachTimeSlot ?? "");
                    return (
                    <div
                      key={timeSlotIndex}
                      className={
                        timeSlotActive[timeSlotIndex]
                          ? "schedule_timings_time_slots_active"
                          : "schedule_timings_time_slots"
                      }
                      onClick={() => {
                        const tmp = [...timeSlotActive];
                        tmp[timeSlotIndex] = !tmp[timeSlotIndex];
                        setTimeSlotActive(tmp);
                      }}
                    >
                      {label}
                    </div>
                    );
                  })}
                </div>
                <div className="schedule_timings_save_slot_button_division">
                  <button
                    type="button"
                    className="btn schedule_timings_save_slot_button"
                    disabled={isSavingSlots}
                    onClick={() => {
                      setIsSavingSlots(true);
                      fetch(window.API_PREFIX + "timing/update_slot", {
                        method: "POST",
                        headers: {
                          "Content-type": "application/json",
                        },
                        body: JSON.stringify({
                          DayTag: WeekDay.indexOf(weekdayActive),
                          SlotActive: timeSlotActive,
                          clinicId: parseInt(clinicId, 10),
                          loginAs: localStorage.getItem("LoginDetails") || "Clinic",
                          doctorId: parseInt(doctorId, 10),
                        }),
                      })
                        .then((resp) => resp.json())
                        .then((data) => {
                          if (data?.status === "1") toast.success("Slots updated");
                          else toast.error(data?.message || "Save failed");
                        })
                        .catch(() => toast.error("Save failed"))
                        .finally(() => setIsSavingSlots(false));
                    }}
                  >
                    {isSavingSlots ? "Saving..." : "Save Slot"}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="mitwank_patient_profile_table_division">
              <Table
                columns={transactionColumns}
                dataSource={transactions}
                pagination={{ pageSize: 10 }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

